export const getVendorName = () => {
    const vendor = JSON.parse(sessionStorage.getItem("vendorData"));
    if(vendor){
        return vendor.tenant_name;
    }
}